// Google Analytics (GA4) – ładowany dynamicznie DOPIERO po zgodzie użytkownika.
// ID pomiaru pochodzi ze zmiennej środowiskowej VUE_APP_GA_ID (patrz .env.production).
// Dzięki temu w środowisku dev (brak zmiennej) analityka się nie uruchamia.

const GA_ID = process.env.VUE_APP_GA_ID;
const CONSENT_KEY = 'cookie_consent';

let initialized = false;

/**
 * Wstrzykuje skrypt gtag.js i inicjalizuje GA4.
 * Wywoływane wyłącznie po uzyskaniu zgody na cookies.
 */
export function loadAnalytics() {
  if (initialized || !GA_ID) return;
  initialized = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', GA_ID, { anonymize_ip: true });
}

/**
 * Uruchamia analitykę, jeśli użytkownik wcześniej wyraził zgodę.
 * Wołane przy starcie aplikacji.
 */
export function initAnalyticsIfConsented() {
  if (localStorage.getItem(CONSENT_KEY) === 'accepted') {
    loadAnalytics();
  }
}

export { CONSENT_KEY };
